<template>
  <div>
    <el-row>
      <el-col :span="12" style="margin-top:30px;margin-left:1%">
        <div class="searchs">
          <div style="float:left;line-height: 30px">搜索内容：</div>
          <el-input clearable style="float:left;width:200px;" v-model="searchContent" placeholder="请输入户名或表号用以检索" size="small"></el-input>
          <el-button type="info" size="small" style="margin-left:1%">搜索</el-button>
        </div>
      </el-col>
    </el-row>
    <el-table
      :data="tableData" 
      :row-class-name="tableRowClassName" 
      border
      style="width: 100%;margin-top: 30px">
      <el-table-column
        fixed
        prop="billTime"
        label="账单时间"
        width="150">
      </el-table-column>
      <el-table-column
        prop="hname"
        label="户名"
        width="120">
      </el-table-column>
      <el-table-column
        prop="hno"
        label="户号"
        width="120">
      </el-table-column>
      <el-table-column
        prop="isPay"
        label="缴费状态"
        width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.isPay==1">已缴</span>
          <span v-if="scope.row.isPay==2">未缴</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="charge"
        label="当期金额"
        width="100">
      </el-table-column>
      <el-table-column
        prop="useWater"
        label="用水量"
        width="80">
      </el-table-column>
      <el-table-column
        prop="image"
        label="抄表图片"
        width="240">
        <template slot-scope="scope">
          <img :src="scope.row.image" style="width:60%;height:40px">
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="150">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="info" size="small">查看</el-button>
          <el-button type="warning" size="small">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float:right;margin-top:20px;margin-right:5%" 
      background
      layout="prev, pager, next"
      @current-change="pageChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="totalSize">
    </el-pagination>
  </div>

</template>
<style>
  .el-table .warning-row {
    background: #F0F0F0;
  }
  .el-table .success-row {
    background: #FFF;
  }
</style>
<script>
  import axios from 'axios'
  import { expire } from '@/utils/auth'
  export default {
    created: function () {
      let result = expire()
      if (!result) {
        this.$router.push('/login')
      }
      this.getData()
    },
    methods: {
      handleClick (row) {
        console.log(row)
      },
      tableRowClassName (row) {
        if (row.isPay === 1) {
          return 'warning-row'
        } else if (row.isPay === 2) {
          return 'success-row'
        }
        return ''
      },
      getData () {
        let pageIndex = this.currentPage
        let url = 'nb/waterBill/getList?filterBy=&orderBy=&pageIndex=' + pageIndex + '&pageSize=10'
        axios.get(url).then(res => {
          if (res.status === 200) {
            console.log(res.data)
            this.tableData = res.data.data
            this.totalSize = res.data.recordsTotal
          } else {
            this.$message({
              message: '系统错误，请联系管理员',
              showClose: true,
              type: 'error'
            })
          }
        })
      },
      pageChange (currentPages) {
        this.currentPage = currentPages
        this.getData()
      }
    },
    data () {
      return {
        tableData: null,
        searchContent: '',
        totalSize: 100,
        currentPage: 1,
        pageSize: 10
      }
    }
  }
</script>




// WEBPACK FOOTER //
// BillNum.vue?a820bcec